import { LinkContext } from '@anm/contexts/LinkContext';
import { VideoTemplatesPageContext } from '@anm/contexts/VideoTemplatesPageContext';
import capitalize from '@anm/helpers/string/capitalize';
import usePageParams from '@anm/hooks/usePageParams';
import { memo, useContext, FC } from 'react';
import { VIDEO_TEMPLATE_ROUTE } from '@anm/constants/routes';
import Wrapper, { Arrow, BreadcrumbItem, ItemWrapper } from './Wrapper';
import { getBreadcrumbsData } from './helpers';

export { getBreadcrumbsData };

const CategoryBreadcrumbs: FC = () => {
  const { embed, isSemrush } = usePageParams();
  const { Link } = useContext(LinkContext);
  const { pageName } = useContext(VideoTemplatesPageContext);

  const breadcrumbs = getBreadcrumbsData(pageName);

  if (breadcrumbs.length < 2) return null;

  return (
    <Wrapper>
      {breadcrumbs.map(({ name, page }, index) => {
        const isLast = breadcrumbs.length - 1 === index;
        const isMainPage = page === 'main';
        const isEmbeddedPage = !!embed;

        const route = isMainPage ? 'video-templates' : VIDEO_TEMPLATE_ROUTE;
        const params =
          isMainPage && isEmbeddedPage
            ? { embed, ...(isSemrush && { isSemrush }) }
            : isMainPage
            ? { ...(isSemrush && { isSemrush }) }
            : { pageName: page, ...(embed && { embed }), ...(isSemrush && { isSemrush }) };

        return (
          <ItemWrapper key={name} {...{ isLast }}>
            <Link {...{ route, params }}>
              <BreadcrumbItem {...{ isLast }}>{capitalize(name, false)}</BreadcrumbItem>
            </Link>
            {!isLast && <Arrow />}
          </ItemWrapper>
        );
      })}
    </Wrapper>
  );
};

export default memo(CategoryBreadcrumbs);
